<app-modal title="Delete User Group" #modalComponent>
  <div class="confirmation-text">
    Do you really want to delete {{ userGroup().email }} user group?
  </div>
  <div class="mt-4 text-end">
    <button class="btn btn-primary-outline btn-form me-3" type="button" (click)="modalComponent.activeModal.close()">
      Close
    </button>
    <button class="btn btn-danger btn-form" type="button" (click)="confirm(modalComponent)" [disabled]="loading()">
      Delete
    </button>
  </div>
</app-modal>